"use client";
import { jsx as e, jsxs as K, Fragment as L } from "react/jsx-runtime";
import { s as h } from "../../../Layout.module-D-Gt5CEC.js";
import N from "classnames";
import { icons as E } from "../../icon/icons.js";
import { useRef as S, useState as M, useEffect as Q } from "react";
import g from "../../icon/Icon.js";
import U from "../_layout/Layout.js";
const v = ({
  description: k,
  disabled: W,
  error: F,
  label: d,
  labelComponentSlot: w,
  optionalText: z,
  prefix: s,
  suffix: a,
  grid: A,
  type: r,
  placeholder: B,
  layoutClassName: C,
  readonly: u,
  childrenWrapperClassName: D,
  hiddenLabel: i,
  message: G,
  ...c
}) => {
  var j, q, I, T;
  const m = (s == null ? void 0 : s.as) || (r === "search" ? "search" : void 0), l = S(null), n = S(null), [t, H] = M({
    prefix: ((j = l == null ? void 0 : l.current) == null ? void 0 : j.clientWidth) || null,
    suffix: ((q = n == null ? void 0 : n.current) == null ? void 0 : q.clientWidth) || null
  });
  Q(() => {
    var o, y;
    H({
      prefix: ((o = l == null ? void 0 : l.current) == null ? void 0 : o.clientWidth) || null,
      suffix: ((y = n == null ? void 0 : n.current) == null ? void 0 : y.clientWidth) || null
    });
  }, []);
  const J = {
    label: d,
    error: F,
    disabled: W,
    description: k,
    optionalText: z,
    labelComponentSlot: w,
    childrenWrapperClassName: D,
    grid: A,
    layoutClassName: C,
    readonly: u,
    hiddenLabel: i,
    message: G,
    suffix: (I = n == null ? void 0 : n.current) == null ? void 0 : I.clientWidth,
    prefix: (T = l == null ? void 0 : l.current) == null ? void 0 : T.clientWidth
  };
  return /* @__PURE__ */ e(U, { required: c.required, name: c.name, ...J, children: /* @__PURE__ */ K(L, { children: [
    !c.hidden && !!m && /* @__PURE__ */ e("span", { ref: l, "data-testid": "prefix", className: N(h.prefix, { [s.className]: !!(s != null && s.className) }), children: typeof m == "string" && m in E ? /* @__PURE__ */ e(g, { name: m }) : m }),
    /* @__PURE__ */ e(
      "input",
      {
        ...c,
        type: r,
        "aria-invalid": !!F,
        "aria-label": i ? d : void 0,
        className: N(c.className, h.input),
        "data-testid": "input",
        disabled: W,
        id: c.name,
        onWheel: (o) => r === "number" ? o.currentTarget.blur() : c.onWheel && c.onWheel(o),
        placeholder: B || (i ? d : void 0),
        style: {
          ...c.style,
          ...!u && (t == null ? void 0 : t.prefix) && { paddingLeft: t == null ? void 0 : t.prefix },
          ...!u && (t == null ? void 0 : t.suffix) && { paddingRight: t == null ? void 0 : t.suffix }
        }
      }
    ),
    !c.hidden && !!(a != null && a.as) && /* @__PURE__ */ e(
      "span",
      {
        ref: n,
        "data-testid": "suffix",
        className: N(h.suffix, {
          [h["subdued-suffix"]]: r === "search",
          [a.className]: !!(a != null && a.className)
        }),
        children: E[a.as] ? /* @__PURE__ */ e(g, { name: a.as }) : a.as
      }
    )
  ] }) });
};
export {
  v as default
};
